
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {OfficialCommentViewModel} from "@/api-client";

@Component({})
export default class RequirementValueChangeComment extends Vue {

  @Prop()
  comment!: OfficialCommentViewModel;
  
  @Prop({required: true})
  canSubmitComment!: boolean;
  
  @Prop({required: true})
  demandComment!: boolean;
  
  @Prop({required: true})
  submitCommentPromise!: (comment: string) => Promise<void>;
  
  newComment = "";
  
  async submitComment() {
    await this.submitCommentPromise(this.newComment);
  }
  
}
